import React, { useMemo } from 'react';
import { Modal } from '../Modal/Modal';

export const HelpDeskModal = ({ isOpen, onClose, values, onChange, onReset, onSubmit, submitting = false, avatarSrc = '' }) => {
  const categories = useMemo(() => ([
    'Accesos y permisos',
    'Hardware',
    'Software',
    'Red / Conectividad',
    'Correo',
    'Contabilidad',
    'SIG',
    'Almacén',
    'Transporte',
    'General',
  ]), []);

  const priorityDot = (p) => {
    if (p === 'Alta') return <span className="inline-block w-2 h-2 rounded-full bg-red-500" />;
    if (p === 'Media') return <span className="inline-block w-2 h-2 rounded-full bg-orange-500" />;
    return <span className="inline-block w-2 h-2 rounded-full bg-green-500" />;
  };
  const selectedPriority = (() => {
    const p = String(values?.priority || '').trim();
    return (p === 'Baja' || p === 'Media' || p === 'Alta') ? p : 'Media';
  })();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="" size="max-w-3xl">
      <div className="flex flex-col items-center gap-4">
        {avatarSrc ? (
          <img
            src={avatarSrc}
            alt="Mesa de Ayuda"
            className="object-contain"
            style={{ width: 300, height: 300, maxWidth: 300, maxHeight: 300 }}
          />
        ) : (
          <div className="w-[84px] h-[84px] rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-gray-500 text-sm">
            TI
          </div>
        )}
        <div className="border border-gray-200 rounded-xl p-4 w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-semibold text-gray-700">Nombre completo *</label>
              <input
                value={values.name || ''}
                onChange={(e) => onChange({ name: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                placeholder="Tu nombre"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-700">Correo electrónico *</label>
              <input
                value={values.email || ''}
                onChange={(e) => onChange({ email: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                placeholder="correo@empresa.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-700">Cédula *</label>
              <input
                value={values.dni || ''}
                onChange={(e) => onChange({ dni: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                placeholder="Ej: 1010228209"
              />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs font-semibold text-gray-700">Título del problema *</label>
              <input
                value={values.subject || ''}
                onChange={(e) => onChange({ subject: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                placeholder="Resume el problema en una línea"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-700">Categoría *</label>
              <select
                value={values.category || ''}
                onChange={(e) => onChange({ category: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
              >
                <option value="">Selecciona una categoría</option>
                {categories.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-700">Área / Departamento</label>
              <input
                value={values.department || ''}
                onChange={(e) => onChange({ department: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                placeholder="Ej: Contabilidad, Ventas..."
              />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs font-semibold text-gray-700">Descripción detallada *</label>
              <textarea
                value={values.description || ''}
                onChange={(e) => onChange({ description: e.target.value })}
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                rows={4}
                placeholder="Describe el problema con el mayor detalle posible: qué pasó, desde cuándo, pasos para reproducirlo..."
              />
            </div>
          </div>

          <div className="mt-4">
            <div className="text-xs font-semibold text-gray-700 mb-2">Prioridad</div>
            <div className="grid grid-cols-3 gap-2">
              {['Baja', 'Media', 'Alta'].map((p) => (
                <button
                  key={p}
                  type="button"
                  onClick={() => onChange({ priority: p })}
                  className={`border rounded-md px-3 py-2 text-sm flex items-center justify-center gap-2 ${selectedPriority === p ? 'font-semibold' : 'hover:bg-gray-50'}`}
                  style={selectedPriority === p ? { backgroundColor: '#FFF7ED', borderColor: '#F07E2D' } : undefined}
                >
                  {priorityDot(p)} {p}
                </button>
              ))}
            </div>
            <div className="text-xs text-gray-500 mt-1">Selecciona “Alta” solo si el problema impide completamente tu trabajo.</div>
          </div>

          <div className="mt-4 flex items-center justify-between gap-3">
            <button type="button" onClick={onReset} className="px-3 py-2 rounded-md border text-sm hover:bg-gray-50">
              Limpiar formulario
            </button>
            <button
              type="button"
              onClick={onSubmit}
              disabled={submitting}
              className="px-4 py-2 rounded-md border text-white text-sm hover:opacity-90 disabled:opacity-60"
              style={{ backgroundColor: '#F07E2D', borderColor: '#F07E2D' }}
            >
              {submitting ? 'Enviando…' : 'Enviar solicitud'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
